//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      top: 0,
      // 初始位置
      isDragging: false,
      viewport: {
        width: 0,
        height: 0
      }
    };
  },
  props: ['text', 'bgColor'],
  mounted: function mounted() {
    var _this = this;

    this.updateViewport();
    window.addEventListener('resize', function () {
      _this.updateViewport(); // 窗口变化时保持按钮可见


      _this.top = _this.clamp(_this.top, 0, _this.viewport.height - _this.$refs.draggableBtn.offsetHeight);
    });
  },
  methods: {
    handleEvent: function handleEvent() {
      this.$emit('click');
    },
    clamp: function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    },
    startDrag: function startDrag(e) {
      var _this2 = this;

      this.isDragging = true;
      var rect = this.$refs.draggableBtn.getBoundingClientRect();
      var offsetY = 120; // e.clientY - rect.top

      var onMouseMove = function onMouseMove(e) {
        if (!_this2.isDragging) return;
        _this2.top = _this2.clamp(e.clientY - offsetY, 0, _this2.viewport.height - rect.height);
      };

      var onMouseUp = function onMouseUp() {
        _this2.isDragging = false;

        _this2.$emit('resize');

        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
      };

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    },
    updateViewport: function updateViewport() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.viewport.height = _this3.$refs.draggableBtn.offsetParent.clientHeight; // 初始位置居中

        _this3.top = 200; // (this.viewport.height - this.$refs.draggableBtn.offsetHeight) / 2
      });
    }
  }
};